module.exports = __webpack_public_path__ + "img/signout.5449fff.svg";